<!--
  RealtimeNotificationManager Component
  Manages the timer and processing of ready notifications
  This component is always included in the base view and handles:
  - Timer for checking ready notifications
  - Event bus listening for MQTT messages
  - Processing ready notifications
-->
<template>
  <!-- This component has no visual output -->
  <div></div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import eventBusConstants from '@/domain/core/constants/eventBus'

export default {
  name: 'RealtimeNotificationManager',
  
  data() {
    return {
      timer: null,
      isProcessing: false
    }
  },
  
  computed: {
    ...mapGetters('realtimeNotifications', [
      'hasScheduledNotifications',
      'scheduledNotifications'
    ])
  },
  
  methods: {
    ...mapActions('realtimeNotifications', [
      'scheduleNotification',
      'emitReadyNotifications'
    ]),
    
    startTimer() {
      if (this.timer) {
        clearInterval(this.timer)
      }
      
      // Check every second for ready notifications
      this.timer = setInterval(() => {
        this.checkForReadyNotifications()
      }, 1000)
    },
    
    stopTimer() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    
    async checkForReadyNotifications() {
      // Avoid overlapping processing
      if (this.isProcessing) return
      
      const scheduledCount = Object.keys(this.scheduledNotifications).length
      
      // If no scheduled notifications, stop the timer
      if (scheduledCount === 0) {
        this.stopTimer()
        return
      }
      
      // Always try to emit ready notifications (the action will check timing)
      this.isProcessing = true
      try {
        await this.emitReadyNotifications()
      } finally {
        this.isProcessing = false
      }
    },
    
    handleMqttMessage(payload) {
      // Schedule notification in store (setTimeout-like behavior)
      this.scheduleNotification(payload)
      
      // Start timer if not already running
      if (!this.timer) {
        this.startTimer()
      }
    }
  },
  
  mounted() {
    // Register for MQTT messages from display types
    this.registerEvent(eventBusConstants.realtimeNotifications.mqtt_message_received, this.handleMqttMessage)
  },
  
  beforeDestroy() {
    // Cleanup
    this.stopTimer()
    this.unregisterEvent(eventBusConstants.realtimeNotifications.mqtt_message_received, this.handleMqttMessage)
  }
}
</script>

<style scoped>
/* No styles needed - this component is invisible */
</style>